export default __webpack_public_path__ + "static/media/mixer.968e1f97.jpg";